<template>
  <div>
    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.bank_name'" rules="required|address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_BANK_ACCOUNT_DETAILS.BANK_NAME') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.bank_name"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.account_owner'" rules="required|name_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_BANK_ACCOUNT_DETAILS.ACCOUNT_OWNER') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.account_owner"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.iban'" rules="required|min:15|max:31|iban|address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_BANK_ACCOUNT_DETAILS.IBAN') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.iban"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.bic'" rules="min:8|max:11|address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_BANK_ACCOUNT_DETAILS.BIC')"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.bic"
        ></v-text-field>
      </validation-provider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankAccountDetails',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    }
  },
  data () {
    return {
      model: {}
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
